import { Navigate, createFileRoute, useRouterState } from '@tanstack/react-router';
import { legacyFeedTarget } from '../lib/feed-search.js';

/** Home became Notifications, which became the Feed; bookmarks and sent alert emails still use this path. */
export const Route = createFileRoute('/home')({
  component: LegacyHomeRedirect,
});

export function LegacyHomeRedirect() {
  const search = useRouterState({ select: (state) => state.location.searchStr });
  const target: string = legacyFeedTarget(search, null);
  return <Navigate to={target} replace />;
}
